import { render } from "./UserProgressReport.vue?vue&type=template&id=6cd31d86&ts=true"
import script from "./UserProgressReport.vue?vue&type=script&lang=ts"
export * from "./UserProgressReport.vue?vue&type=script&lang=ts"

import "./UserProgressReport.vue?vue&type=style&index=0&id=6cd31d86&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__